export default function RecentCard() {
  return (
    <div className="flex flex-col gap-6 md:gap-11">
      <div className="flex items-center gap-2 md:gap-5">
        <div className="w-[76px] md:h-[81px] ">
          <img src="/home/footer-1.png" alt="footer" />
        </div>
        <div className="flex flex-col h-full justify-center">
          <p className="text-primary text-[12px] md:text-[15px]">Jan 2, 2024</p>
          <p className="max-w-[227px] text-xs md:text-base">
            How to make lorem ipsum diet do lorem amet .
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2 md:gap-5">
        <div className="w-[76px] md:h-[81px] ">
          <img src="/home/footer-2.png" alt="footer" />
        </div>
        <div className="flex flex-col h-full justify-center">
          <p className="text-primary text-[12px] md:text-[15px]">Jan 2, 2024</p>
          <p className="max-w-[227px] text-xs md:text-base">
            How to make lorem ipsum diet do lorem amet .
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2 md:gap-5">
        <div className="w-[76px] md:h-[81px] ">
          <img src="/home/footer-3.png" alt="footer" />
        </div>
        <div className="flex flex-col h-full justify-center">
          <p className="text-primary text-[12px] md:text-[15px]">Jan 2, 2024</p>
          <p className="max-w-[227px] text-xs md:text-base">
            How to make lorem ipsum diet do lorem amet .
          </p>
        </div>
      </div>
    </div>
  );
}
